<template>
  <div class="treatment-page">
    <div class="hero-section">
      <div class="container">
        <h1>Mondhygiëne & Professionele Reiniging Sint-Michielsgestel</h1>
        <p class="lead">Professionele mondverzorging en tandreinigingen bij Tandzorg Gestel. Voorkom tandvleesontsteking en houd uw tanden gezond met onze mondhygiënisten.</p>
      </div>
    </div>

    <div class="content-section">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <h2>Het belang van goede mondhygiëne</h2>
            <p>Goede mondhygiëne is de basis voor een gezonde mond en algemene gezondheid. Bij Tandzorg Gestel in Sint-Michielsgestel hebben onze ervaren mondhygiënisten jarenlange ervaring in het behandelen en voorkomen van tandvlees- en kaakproblemen.</p>

            <p>Regelmatige professionele reiniging door onze mondhygiënisten helpt niet alleen bij het voorkomen van gaatjes en tandvleesproblemen, maar draagt ook bij aan uw algehele welzijn. Onderzoek toont aan dat slechte mondhygiene kan leiden tot hart- en vaatziekten, diabetes complicaties en andere gezondheidsproblemen.</p>

            <h2>Onze mondhygiëne diensten</h2>
            
            <h3>Professionele Tandreinigingen</h3>
            <p>Onze mondhygiënisten voeren grondige reinigingen uit die verder gaan dan wat u thuis kunt bereiken:</p>
            <ul>
              <li><strong>Tandsteen verwijdering</strong> - hardnekkige afzettingen die thuis niet weg te krijgen zijn</li>
              <li><strong>Plaque removal</strong> - bacteriële aanslag die tandvleesontsteking veroorzaakt</li>
              <li><strong>Polijsten</strong> - voor gladde, schone tandoppervlakken</li>
              <li><strong>Fluoride behandeling</strong> - versterkt tandglazuur tegen cariës</li>
            </ul>

            <h3>Periodontale Behandeling</h3>
            <p>Voor patiënten met tandvleesproblemen bieden wij gespecialiseerde behandelingen:</p>
            <ul>
              <li><strong>Deep cleaning (scaling & root planing)</strong> - dieptereiniging van tandvleeszakken</li>
              <li><strong>Gingivitis behandeling</strong> - behandeling van tandvleesontsteking</li>
              <li><strong>Parodontitis zorg</strong> - behandeling van ernstige tandvleesaandoeningen</li>
              <li><strong>Onderhoudsprogramma's</strong> - preventieve zorg op maat</li>
            </ul>

            <h3>Preventieve Zorg</h3>
            <p>Voorkomen is beter dan genezen. Onze preventieve programma's omvatten:</p>
            <ul>
              <li><strong>Risico-assessment</strong> - bepaling van uw individuele risicofactoren</li>
              <li><strong>Mondgezondheidsadvies</strong> - persoonlijke tips voor thuisverzorging</li>
              <li><strong>Sealing</strong> - bescherming van kiezen tegen cariës</li>
              <li><strong>Reguliere controles</strong> - vroege detectie van problemen</li>
            </ul>

            <h2>Het behandelproces</h2>
            
            <h3>Stap 1: Intake en Onderzoek</h3>
            <p>Tijdens uw eerste bezoek maken we een complete assessment van uw mondgezondheid. We bespreken uw medische geschiedenis, huidige klachten en mondverzorgingsgewoonten.</p>

            <h3>Stap 2: Behandelplan</h3>
            <p>Op basis van onze bevindingen stellen we een persoonlijk behandelplan op. Dit kan variëren van een standaard reiniging tot intensievere periodontale zorg.</p>

            <h3>Stap 3: Behandeling</h3>
            <p>De behandeling wordt uitgevoerd door onze gekwalificeerde mondhygiënisten. We gebruiken moderne technieken en apparatuur voor optimaal comfort en resultaat.</p>

            <h3>Stap 4: Nazorg en Planning</h3>
            <p>Na de behandeling krijgt u uitgebreide instructies voor thuisverzorging. We plannen vervolgafspraken volgens uw individuele behoeften.</p>

            <h2>Signalen dat u een mondhygiënist nodig heeft</h2>
            <p>Plan een afspraak bij onze mondhygiënist als u één of meer van deze symptomen heeft:</p>
            <ul>
              <li><strong>Bloedend tandvlees</strong> bij poetsen of flossen</li>
              <li><strong>Gezwollen of rood tandvlees</strong></li>
              <li><strong>Aanhoudende slechte adem</strong> (halitose)</li>
              <li><strong>Tandsteen opbouw</strong> - gelige/bruine afzettingen</li>
              <li><strong>Pijnlijk of gevoelig tandvlees</strong></li>
              <li><strong>Losse tanden</strong> of verandering in bijstand</li>
              <li><strong>Meer dan 6 maanden</strong> geleden laatste reiniging</li>
            </ul>

            <h2>Voordelen van professionele mondhygiëne</h2>
            <ul>
              <li><strong>Preventie van tandvliesziekte</strong> - vroege detectie en behandeling</li>
              <li><strong>Voorkoming van tandelosheid</strong> - behoud van uw eigen tanden</li>
              <li><strong>Frisse adem</strong> - eliminatie van bacteriën die slechte adem veroorzaken</li>
              <li><strong>Gezondere glimlach</strong> - schonere, wittere tanden</li>
              <li><strong>Kostenbesparing</strong> - preventie voorkomt dure behandelingen</li>
              <li><strong>Algemene gezondheid</strong> - vermindert risico op hart- en vaatziekten</li>
            </ul>

            <h2>Hoe vaak naar de mondhygiënist?</h2>
            <p>De frequentie van bezoeken aan onze mondhygiënist hangt af van uw individuele situatie:</p>
            <ul>
              <li><strong>Standaard:</strong> Elke 6 maanden voor gezonde monden</li>
              <li><strong>Verhoogd risico:</strong> Elke 3-4 maanden bij diabetes, roken, of genetische aanleg</li>
              <li><strong>Tandvleesproblemen:</strong> Maandelijks tot driemaandelijks tijdens actieve behandeling</li>
              <li><strong>Onderhoud:</strong> Persoonlijk schema na behandeling van tandvleesziekte</li>
            </ul>

            <h2>Tips voor thuisverzorging</h2>
            <p>Onze mondhygiënisten geven u persoonlijk advies, maar hier zijn algemene richtlijnen:</p>
            <ul>
              <li><strong>Poets 2x per dag</strong> met fluoride tandpasta</li>
              <li><strong>Floss dagelijks</strong> of gebruik interdentale borsteltjes</li>
              <li><strong>Mondwater</strong> kan helpen bij bacteriëbestrijding</li>
              <li><strong>Vervang tandenborstel</strong> elke 3-4 maanden</li>
              <li><strong>Gezonde voeding</strong> - beperk suiker en zure dranken</li>
              <li><strong>Stop met roken</strong> - grote risicofactor voor tandvliesziekte</li>
            </ul>

            <h2>Kosten en verzekering</h2>
            <p>Mondhygiëne behandelingen vallen meestal onder uw aanvullende tandartsverzekering. We hebben contracten met alle grote verzekeraars en helpen u graag bij het indienen van declaraties.</p>

            <h2>Ons mondhygiëne team</h2>
            <p>Bij Tandzorg Gestel werken ervaren, geregistreerde mondhygiënisten die regelmatig bijscholing volgen. Ze zijn gespecialiseerd in preventieve zorg en behandeling van tandvlees- en kaakproblemen. Ons team staat bekend om hun zachte aanpak en uitgebreide patiënteducatie.</p>
          </div>

          <div class="col-md-4">
            <div class="appointment-card">
              <h3>Plan uw reiniging</h3>
              <p>Houd uw tanden en tandvlees gezond met regelmatige professionele reiniging.</p>
              <router-link to="/contact" class="link-btn">Contact opnemen</router-link>
              <router-link to="/afspraak-maken" class="link-btn">Afspraak maken</router-link>
              
              <div class="contact-info">
                <h4>Contact</h4>
                <p>📞 <a href="tel:+31735515644" class="contact-link">073-5515644</a></p>
                <p>✉️ <a href="mailto:info@tandzorggestel.nl" class="contact-link">info@tandzorggestel.nl</a></p>
                <p>📍 Schijndelseweg 13A<br>5271 BK Sint-Michielsgestel</p>
              </div>
            </div>

            <div class="hygiene-tips">
              <h4>Mondhygiëne Tips</h4>
              <p><strong>Wist u dat...</strong></p>
              <ul>
                <li>Tandvliesziekte de hoofdoorzaak is van tandelosheid?</li>
                <li>Professionele reiniging plagen weghaalt die u thuis niet kunt bereiken?</li>
                <li>Goede mondhygiëne uw immuunsysteem versterkt?</li>
                <li>Regelmatige controle geld kan besparen door vroege detectie?</li>
              </ul>
            </div>

            <div class="related-treatments">
              <h4>Gerelateerde behandelingen</h4>
              <ul>
                <li><router-link to="/wortelkanaalbehandeling">Wortelkanaalbehandeling</router-link></li>
                <li><router-link to="/cosmetische-tandheelkunde">Cosmetische tandheelkunde</router-link></li>
                <li><router-link to="/vullingen">Vullingen en reparaties</router-link></li>
                <li><router-link to="/kronen-bruggen">Kronen en bruggen</router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mondhygiene',
  mounted() {
    // SEO optimization
    document.title = "Mondhygiëne Sint-Michielsgestel | Tandzorg Gestel | Professionele Tandreinigingen";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professionele mondhygiëne en tandreinigingen bij Tandzorg Gestel in Sint-Michielsgestel. Ervaren mondhygiënisten, tandvlees behandeling, preventieve zorg.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'mondhygiëne, mondhygiënist, tandreiningen, tandvlees, periodontologie, plaque, tandsteen, Sint-Michielsgestel, Tandzorg Gestel');
    }
    
    // Schema.org structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "MedicalProcedure",
      "name": "Mondhygiëne en Professionele Tandreinigingen",
      "description": "Professionele mondhygiëne behandelingen bij Tandzorg Gestel in Sint-Michielsgestel",
      "provider": {
        "@type": "Dentist",
        "name": "Tandzorg Gestel",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Schijndelseweg 13A",
          "addressLocality": "Sint-Michielsgestel",
          "postalCode": "5271 BK",
          "addressCountry": "NL"
        },
        "telephone": "+31735515644"
      },
      "medicalSpecialty": "Periodontics",
      "includesOperation": [
        "Professionele tandreinigingen",
        "Tandsteen verwijdering",
        "Periodontale behandeling",
        "Preventieve zorg"
      ]
    });
    document.head.appendChild(script);
  }
}
</script>

<style scoped>
.treatment-page {
  padding-top: 88px;
}

.hero-section {
  background: linear-gradient(135deg, var(--blue), #0099a3);
  color: white;
  padding: 4rem 0;
  text-align: center;
}

.hero-section h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: bold;
}

.lead {
  font-size: 1.3rem;
  max-width: 600px;
  margin: 0 auto;
}

.content-section {
  padding: 4rem 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.row {
  display: flex;
  gap: 3rem;
}

.col-md-8 {
  flex: 2;
}

.col-md-4 {
  flex: 1;
}

.content-section h2 {
  color: var(--blue);
  font-size: 2.2rem;
  margin: 2rem 0 1rem 0;
}

.content-section h3 {
  color: var(--black);
  font-size: 1.5rem;
  margin: 1.5rem 0 0.5rem 0;
}

.content-section p {
  line-height: 1.8;
  margin-bottom: 1rem;
  color: var(--light-color);
  font-size: 1.6rem;
}

.content-section ul {
  margin: 1rem 0;
  padding-left: 2rem;
}

.content-section li {
  margin-bottom: 0.5rem;
  color: var(--light-color);
  font-size: 1.6rem;
  line-height: 1.6;
}

.appointment-card {
  background: var(--light-bg);
  padding: 2rem;
  border-radius: 10px;
  margin-bottom: 2rem;
  box-shadow: var(--box-shadow);
}

.appointment-card h3 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.appointment-card .link-btn {
  display: block;
  margin-bottom: 1rem;
  text-align: center;
}

.contact-info {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #ddd;
}

.contact-info h4 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.hygiene-tips {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: var(--box-shadow);
  margin-bottom: 2rem;
}

.hygiene-tips h4 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.hygiene-tips ul {
  list-style: none;
  padding: 0;
}

.hygiene-tips li {
  margin-bottom: 0.8rem;
  font-size: 1.4rem;
  color: var(--light-color);
}

.related-treatments {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: var(--box-shadow);
}

.related-treatments h4 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.related-treatments ul {
  list-style: none;
  padding: 0;
}

.related-treatments li {
  margin-bottom: 0.5rem;
}

.related-treatments a {
  color: var(--light-color);
  text-decoration: none;
  font-size: 1.4rem;
}

.related-treatments a:hover {
  color: var(--blue);
}

@media (max-width: 768px) {
  .row {
    flex-direction: column;
    gap: 2rem;
  }
  
  .hero-section h1 {
    font-size: 2.5rem;
  }
  
  .lead {
    font-size: 1.1rem;
  }
  
  .content-section {
    padding: 2rem 0;
  }
}
</style>
